import { gql } from "apollo-boost";

export const CLUB_MERGE = gql`
  mutation clubMerge(
    $clubId: Int
    $clubCode: String!
    $clubName: String!
    $clubDesc: String
    $password: String
    $logo: String
    $email: String
    $userId: Int
    $visibility: Int
    $countryId: Int
    $createDate: Date
    $latitude: Float
    $longitude: Float
    $year: Int
    $updateSource: String
  ) {
    clubMerge(
      clubData: {
        clubId: $clubId
        clubCode: $clubCode
        clubName: $clubName
        clubDesc: $clubDesc
        password: $password
        logo: $logo
        email: $email
        userId: $userId
        visibility: $visibility
        countryId: $countryId
        createDate: $createDate
        latitude: $latitude
        longitude: $longitude
        year: $year
        updateSource: $updateSource
      }
    ) {
      node {
        clubId
        clubCode
        clubName
        clubDesc
        email
        logo
        userId
        visibility
        countryId
        latitude
        longitude
        createDate
        year
        updateSource
      }
    }
  }
`;

export const CLUB_DELETE = gql`
  mutation ClubDelete($clubId: Int!) {
    clubDelete(clubId: $clubId) {
      status
    }
  }
`;
export const GROUP_MERGE = gql`
  mutation MutateGroup(
    $teamId: Int
    $teamName: String!
    $year: Int
    $toYear: Int
    $clubId: Int
    $visibility: Int
    $sportType: String
    $logo: String
    $orderOnUi: Int
    $updateSource: String
    $competitiveFlag: Int
    $studentCoachRatio: Int
    $monthlyFee: Int
    $registrationFee: Int
    $fundrasingFee: Int
    $maxAthletes: Int
    $coaches: String
    $teamDescription: String
    $commitmentRequirements: String
  ) {
    groupMerge(
      groupData: {
        teamId: $teamId
        teamName: $teamName
        year: $year
        toYear: $toYear
        clubId: $clubId
        visibility: $visibility
        sportType: $sportType
        logo: $logo
        orderOnUi: $orderOnUi
        updateSource: $updateSource
        competitiveFlag: $competitiveFlag
        studentCoachRatio: $studentCoachRatio
        monthlyFee: $monthlyFee
        registrationFee: $registrationFee
        fundrasingFee: $fundrasingFee
        maxAthletes: $maxAthletes
        coaches: $coaches
        teamDescription: $teamDescription
        commitmentRequirements: $commitmentRequirements
      }
    ) {
      node {
        teamId
        teamName
        year
        toYear
        clubId
        visibility
        sportType
        logo
        orderOnUi
        updateSource
        competitiveFlag
        studentCoachRatio
        monthlyFee
        registrationFee
        fundrasingFee
        maxAthletes
        coaches
        teamDescription
        commitmentRequirements
      }
    }
  }
`;

export const GROUP_DELETE = gql`
  mutation GroupDelete($teamId: Int!) {
    groupDelete(teamId: $teamId) {
      status
    }
  }
`;

export const CLUB_TERM_MERGE = gql`
mutation clubTermMutate(
  $seqNo: Int,
  $name: String!,
  $clubId: Int!,
  $startDate: String!,
  $endDate: String!,
  $updateSource: String!
) {
  clubTermMutate(programData: {
    seqNo: $seqNo,
    name: $name,
    clubId: $clubId,
    startDate: $startDate,
    endDate: $endDate,
    updateSource: $updateSource
  }) {
    edges {
      node {
        seqNo
        name
        startDate
        endDate
        clubId
      }
    }
  }
}
`;

export const CLUB_TERM_DELETE = gql`
mutation clubTermDelete($seqNo: Int!) {
  clubTermDelete(seqNo: $seqNo) {
    success
    message
  }
}
`;